// === INPACT:SLUITSTRAAT:BOILERPLATE:NOT-FOUND-PAGE:v1 ===

import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.code}>404</h1>
        <h2 style={styles.title}>Pagina niet gevonden</h2>
        <p style={styles.message}>
          De pagina die u zoekt bestaat niet of is verplaatst.
        </p>
        <Link to="/" style={styles.link}>
          Terug naar home
        </Link>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    padding: '20px',
  },
  content: {
    textAlign: 'center' as const,
    maxWidth: '500px',
  },
  code: {
    fontSize: '120px',
    fontWeight: 'bold' as const,
    color: 'var(--primary-color, #1976d2)',
    margin: 0,
  },
  title: {
    fontSize: '32px',
    color: '#333',
    marginBottom: '16px',
  },
  message: {
    fontSize: '18px',
    color: '#666',
    marginBottom: '32px',
    lineHeight: '1.6',
  },
  link: {
    display: 'inline-block',
    padding: '12px 32px',
    backgroundColor: 'var(--primary-color, #1976d2)',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: 'bold' as const,
  },
};

export default NotFoundPage;
